export const SHOPIFY_APP_STORE_URL = "https://apps.shopify.com/shakatah";
export const SHOPIFY_APP_HANDLE =
  ((import.meta.env.VITE_SHOPIFY_APP_HANDLE as string | undefined)?.trim() || "shakatah");

export function buildShopifyManagedPricingUrl(shopDomain?: string | null): string {
  const normalizedShop = String(shopDomain || "").trim().toLowerCase();
  const storeHandle = normalizedShop.replace(/\.myshopify\.com$/, "");

  if (!storeHandle) {
    return SHOPIFY_APP_STORE_URL;
  }

  return `https://admin.shopify.com/store/${encodeURIComponent(storeHandle)}/charges/${encodeURIComponent(
    SHOPIFY_APP_HANDLE,
  )}/pricing_plans`;
}
